import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setEmpAttendanceEmpEmpAction, setTheUserIDFroCRUD, setTheBranchInlatANDLog, settheEmpAttendanceBoolValues, settheEmployeeUdsImages, setTheCheckingIn } from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import _, { values } from "lodash";
import approved from "../../../Assets/MainComponent/approved.svg";
import declined from "../../../Assets/MainComponent/decline.svg";
import pending from "../../../Assets/MainComponent/pending.svg";
import HeadingComp from "./UdsEmployeeDashboard/CustomHooks/HeadingComp";
import data from "../../../Json/Language/English";
import hindiDatas from "../../../Json/Language/Hinid";
import useLanguageSelector from "./UdsEmployeeDashboard/CustomHooks/useLanguageSelector";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import Onduty from "../../../Assets/AppComponent/AttendanceImages/OnDutyIm.png";
import overtimeimg from "../../../Assets/AppComponent/AttendanceImages/otIcon.svg";
import PunchInAndPunchOutIMgs from "../../../Assets/AppComponent/AttendanceImages/employeePermission.png";


import attendanceregularimg from "../../../Assets/AppComponent/AttendanceImages/emOnduty.png";
import EmpCheckoutAndChecking from "./EmpCheckoutAndChecking";

export const EmployeeAttendanceEMP = () => {
    const state = useSelector((state) => state)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const EnglishData = data;
    const HindiData = hindiDatas;
    const hindiApplyLeave = HindiData;

    const [createEditPopup, setCreateEditPopup] = useState(false);
    const [editPayload, setEditPayload] = useState({});
    const [dtpageindex, setdtPageindex] = useState(1);
    const [dtpagesize, setdtPagesize] = useState(10);
    const [EmpChecking, setEmpCheckingSt] = useState(false)
    const [search, setsearch] = useState("")
    const [sno, setsno] = useState(0);

    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );

    const FileterState = {
        Present: false,
        Leave: false,
        Working: false,
    }
    const [selectVal, SetSelectval] = useState(FileterState);
    const [OptionValues, setOptionvalues] = useState([{ value: "", label: "All" }])

    const options = [
        { value: "", label: "All" },
        { value: "Present", label: "Present" },
        { value: "Leave", label: "Leave" },
        { value: "Working", label: "Working" },
    ];
    // State for selected IDs
    const [selectedIds, setSelectedIds] = useState([]);

    // Handle radio button change
    const handleSelect = (id) => {
        setSelectedIds(id);
        dispatch(setTheUserIDFroCRUD(id))

    };

    const todayDate = new Date();
    console.log(todayDate.getDate(), todayDate.getMonth() + 1, todayDate.getFullYear(), "AOISU todayDate");

    useEffect(() => {
        if (EmpChecking == false) {
            const payload = {
                page_size: 20,
                page: dtpageindex,
                search: search,
                all: true,
                present: selectVal.Present,
                leave: selectVal.Leave,
                working: selectVal.Working,
                date: `${todayDate.getFullYear()}-${todayDate.getMonth() + 1}-${todayDate.getDate()}`
            };
            dispatch(setEmpAttendanceEmpEmpAction(payload));
        }
    }, [dtpageindex, search, selectVal, EmpChecking]);

    const capitalizeFirstLetter = (Letter) => {
        return Letter.charAt(0).toUpperCase() + Letter.slice(1);
    };
    const handleNext = (next) => {
        setdtPageindex(next + 1);
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage)
    }

    const handlePrevious = (previous) => {
        if (previous != 0) {
            setdtPageindex(previous);
        }
    };
    const pagesize = (arg) => {
        setdtPagesize(arg);
    };

    const pageindex = (arg) => {
        setdtPageindex(arg);
    };

    const ClearState = (counts) => {
        setOptionvalues({ value: "", label: "All" })
        SetSelectval({
            ...selectVal,
            Present: false,
            Leave: false,
            Working: false,

        });
    };

    const count = (Counts, values, sel, SelectedValues) => {
        setOptionvalues(SelectedValues)
        if (SelectedValues.value == "Present") {
            SetSelectval({
                ...selectVal,
                Present: true,
                Leave: false,
                Working: false,

            });
        }

        if (SelectedValues.value == "") {
            SetSelectval({
                ...selectVal,
                Present: false,
                Leave: false,
                Working: false,

            });
        }

        if (SelectedValues.value == "Leave") {
            SetSelectval({
                ...selectVal,
                Present: false,
                Leave: true,
                Working: false,

            });
        }
        if (SelectedValues.value == "Working") {
            SetSelectval({
                ...selectVal,
                Present: false,
                Leave: false,
                Working: true,

            });
        }

    };


    const columns =
        useMemo(
            () => [
                {
                    Header: "S.NO",
                    accessor: "",
                    Cell: (row) => {
                        console.log(row.row);
                        console.log(sno);
                        return <p>{Number(sno + row.row.index + 1)}</p>;
                    },
                },
                {
                    Header: "Employee Name",
                    accessor: "",
                    Cell: (row) => {
                        return (
                            <>
                                {row.row.original.user_id.first_name ? (
                                    <span>{row.row.original.user_id.first_name}</span>
                                ) : (
                                    <span>---</span>
                                )}
                            </>
                        );
                    },
                },
                {
                    Header: "Designation",
                    accessor: "",
                    Cell: (row) => {
                        return (
                            <>
                                {row.row.original.user_id.user_role != null &&
                                    row.row.original.user_id.user_role != undefined ? (
                                    <span>{row.row.original.user_id.user_role.role}</span>
                                ) : (
                                    <span>---</span>
                                )}
                            </>
                        );
                    },
                },

                {
                    Header: "Client",
                    accessor: "",
                    Cell: (row) => {
                        return (
                            <>
                                {row.row.original.client_name != null &&
                                    row.row.original.client_name != undefined ? (
                                    <span>{row.row.original.client_name}</span>
                                ) : (
                                    <span>---</span>
                                )}
                            </>
                        );
                    },
                },

                {
                    Header: "Zone",
                    accessor: "",
                    Cell: (row) => {
                        return (
                            <>
                                {row.row.original.zone_name != null &&
                                    row.row.original.zone_name != undefined ? (
                                    <span>{row.row.original.zone_name}</span>
                                ) : (
                                    <span>---</span>
                                )}
                            </>
                        );
                    },
                },
                {
                    Header: "Actions",
                    accessor: "",
                    Cell: (row) => {
                        const [hovered, setHovered] = useState(null);

                        return (
                            <>
                                <div
                                    class="actions"
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        gap: "5px",
                                    }}
                                >

                                    {/* <button
                                        class="btn SiteTransferBtm"
                                        style={{ background: "#d8e2fb", color: "#234492", position: "relative" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            dispatch(setTheUserIDFroCRUD(row.row.original.user_id.id))
                                            navigate("/ondutyemp")
                                        }}
                                        onMouseEnter={() => setHovered("On Duty")}
                                        onMouseLeave={() => setHovered(null)}
                                    >
                                        <span className="ExcelSheetImages">
                                            <img src={Onduty} />
                                            {hovered === "On Duty" && (
                                                <div className="custom-tooltip">On Duty</div>
                                            )}
                                        </span>
                                    </button> */}

                                    <button
                                        class="btn SiteTransferBtm"
                                        style={{ background: "#d8e2fb", color: "#234492", position: "relative" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            dispatch(setTheUserIDFroCRUD(row.row.original.user_id.id))
                                            navigate("/attendanceregularization")
                                        }}
                                        onMouseEnter={() => setHovered("Attendance Regularization")}
                                        onMouseLeave={() => setHovered(null)}
                                    >
                                        <span className="ExcelSheetImages">
                                            <img src={attendanceregularimg} />
                                            {hovered === "Attendance Regularization" && (
                                                <div className="custom-tooltip">Attendance Regularization</div>
                                            )}
                                        </span>
                                    </button>

                                    <button
                                        class="btn SiteTransferBtm"
                                        style={{ background: "#d8e2fb", color: "#234492", position: "relative" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            dispatch(setTheUserIDFroCRUD(row.row.original.user_id.id))
                                            navigate("/overtimeemp")
                                        }}
                                        onMouseEnter={() => setHovered("Overtime Regualrization")}
                                        onMouseLeave={() => setHovered(null)}
                                    >
                                        <span className="ExcelSheetImages">
                                            <img src={overtimeimg} />
                                            {hovered === "Overtime Regualrization" && (
                                                <div className="custom-tooltip">Overtime Regualrization</div>
                                            )}
                                        </span>
                                    </button>
                                    {row.row.original.user_id != null && row.row.original.user_id != undefined &&
                                        row.row.original.user_id.user_role.white_collar === false &&
                                        row.row.original.user_id.user_image != null &&
                                        row.row.original.user_id.user_image.media_url != null &&
                                        row.row.original.user_id.user_image.media_url != undefined &&
                                        row.row.original.user_id.user_image.media_url != ""
                                        ?
                                        <button
                                            class="btn SiteTransferBtm"
                                            style={{ background: "#d8e2fb", color: "#234492", position: "relative" }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                const Branch = {

                                                    latitude: row.row.original.latitude,
                                                    longitude: row.row.original.longitude
                                                };
                                                dispatch(setTheBranchInlatANDLog(Branch));
                                                dispatch(settheEmpAttendanceBoolValues(row.row.original.user_id.user_role.white_collar))
                                                dispatch(setTheUserIDFroCRUD(row.row.original.user_id.id))
                                                // navigate("/overtimeemp")
                                                dispatch(setTheCheckingIn(row.row.original.check_in))
                                                dispatch(settheEmployeeUdsImages(row.row.original.user_id.user_image.media_url))
                                                setEmpCheckingSt(true);
                                            }}
                                            onMouseEnter={() => {
                                                if (row.row.original.check_in === true) {
                                                    setHovered("Punch Out")
                                                }
                                                else {
                                                    setHovered("Punch In")
                                                }
                                            }}
                                            onMouseLeave={() => setHovered(null)}
                                        >
                                            <span className="ExcelSheetImages">
                                                <img src={PunchInAndPunchOutIMgs} />
                                                {((hovered === "Punch In") || (hovered === "Punch Out")) && (
                                                    <div className="custom-tooltip">
                                                        {row.row.original.check_in === true ? "Punch Out" : "Punch In"}
                                                    </div>
                                                )}
                                            </span>
                                        </button>
                                        : null}

                                </div>
                            </>
                        );
                    },
                },



            ], [sno]
        );


    // -----Search------------------------
    function tochange(e) {
        setdtPageindex(1);
        debouncedSearch(e);

    }
    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setsearch(e);
            }, 500),
        []
    );
    React.useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);


    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div className="leaveWrapper">

                    <div className="row ButtonPrevious Filters"
                        style={{
                            padding: "4px 4px",
                            margin: "0px",
                            position: "relative",
                            zIndex: "30",
                            marginLeft: "0px",
                            marginRight: "0px", marginBottom: "3px"

                        }}>

                        <div className="col-12 leaveHeading text-left">
                            <h3>EMPLOYEE ATTENDANCE</h3>
                        </div>

                        <div className="col">
                            <button
                                className="btn BackImga"
                                onClick={(e) => {
                                    navigate("/teamemp");
                                }}
                            >
                                <img className="PreviousPages" src={BackImage} />
                                <span></span>
                            </button>
                        </div>
                        <div className="col DateFilterCOlumns">
                            <h3> Today : <span>{todayDate.getDate()}-{todayDate.getMonth() + 1}-{todayDate.getFullYear()}</span> </h3>
                        </div>
                    </div>




                    <div className="col-12 leaveSubHeading">
                        <ReactTable
                            data={state.EmpAttendaEmpDataGetList.EmployeeAttendanceEMpDatas}
                            datacount={state.EmpAttendaEmpDataGetList.Total_Count}
                            columns={columns}
                            pagesize={pagesize}
                            dtpagesize={20}
                            dtpageindex={dtpageindex}
                            pageindex={pageindex}
                            onPrevious={handlePrevious}
                            onNextpage={handleNext}
                            GotoEnteredPage={GotoEnteredPage}
                            MakeCreate={false}
                            Filter={true}
                            // NoFilter={true}
                            onChange={tochange}

                            values={OptionValues}
                            options={options}
                            count={count}
                            ClearState={ClearState}
                            Search={false}
                            setsno={setsno}
                            sno={sno}
                            id={"spe"}

                        />

                    </div>
                </div>
            </div>

            {
                EmpChecking == true ?
                    <EmpCheckoutAndChecking show={EmpChecking} setShow={setEmpCheckingSt} /> : null}



        </>


    )
}
